<template>
  <List>
    <RecycleScroller
      v-infinite-scroll="handleInfiniteOnLoad"
      :style="scrollStyle"
      :items="dataSource"
      :min-item-size="minItemSize"
      :item-size="itemSize"
      :size-field="sizeField"
      :key-field="keyField"
      :prerender="prerender"
      :infinite-scroll-disabled="finished"
      :infinite-scroll-distance="10"
    >
      <div class="ant-list-item" slot-scope="{ item }">
        <slot :item="item" />
      </div>
    </RecycleScroller>
    <Spin v-if="loading" class="spin-loading" />
  </List>
</template>
<script lang="ts">
import { RecycleScroller } from 'vue-virtual-scroller'
import { List, Spin } from 'ant-design-vue'

// 本组件不考虑横向滚动加载的情况

export default {
  name: 'WaterfallList',
  components: {
    RecycleScroller,
    List,
    Spin,
  },

  props: {
    nextVer: { // 当前加载的"版本", 变化时finished状态将变更为false
      type: [Number, String],
      required: true
    },
    dataSource: {
      type: Array,
      required: true,
    },
    fetchData: {
      // lastItem的作用：可能存在使用lastId分页的情况
      /** @type {PropType<
        <T>(
          index?: number,
          lastItem?: T
        ) => Promise<boolean> //finished
      >} */
      type: Function,
      required: true,
    },

    keyField: {
      // 唯一标识
      type: String,
      default: 'id',
    },
    minItemSize: {
      type: [Number, String],
      default: null,
    },
    itemSize: {
      // 预期每一项的高度
      type: Number,
      default: null,
    },
    sizeField: {
      // itemSize和sizeField二选一必传
      type: String,
      default: 'size',
    },
    prerender: {
      type: Number,
      default: 0,
    },
    scrollStyle: {
      // 通常限定高度 例如 "height: 400px"
      type: [Object, String],
    }
  },

  data() {
    return {
      loading: false,
      finished: false,
    }
  },
  methods: {
    async handleInfiniteOnLoad() {
      if (this.finished || this.loading) {
        return true
      }
      this.loading = true
      try {
        const finished = await this.fetchData()
        this.finished = finished
      } catch (err) {
        this.finished = false
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    nextVer() {
      this.finished = false
      this.handleInfiniteOnLoad()
    }
  }
}
</script>
<style lang="less">
.spin-loading {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}

.hide-scroll .vue-recycle-scroller {
  &::-webkit-scrollbar-thumb {
    background: transparent !important;
  }
}
</style>
